"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _layoutHeroModule = _interopRequireDefault(require("./sass/layoutHero.module.scss"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayoutHero = function LayoutHero(_ref) {
  var children = _ref.children,
      image = _ref.image;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: _layoutHeroModule.default.layoutHero
  }, /*#__PURE__*/_react.default.createElement("div", null, children), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "layoutImg"
  }, image));
};

LayoutHero.defaultProps = {
  image: null
};
LayoutHero.propTypes = {
  image: _propTypes.default.object,
  children: _propTypes.default.object
};
var _default = LayoutHero;
exports.default = _default;